import $ from 'jquery';
import GoogleMapsServiceStub from './google_maps_service_stub';

class GoogleMapsService {
  loadSdk() {
    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.loadPromise = new Promise((resolve, reject) => {
      const failTimeout = setTimeout(reject, 30000);

      window.googleMapsInit = () => {
        clearTimeout(failTimeout);
        resolve(window.google);
      };

      $.ajax({
        url: `//maps.googleapis.com/maps/api/js?libraries=places&sensor=false&language=pt-BR&key=${window.google_api_key}&callback=googleMapsInit`,
        dataType: 'script',
        cache: true,
      });
    });

    return this.loadPromise;
  }

  // Uses google maps api to get an location from (lat, lng)
  geocode(lat, lng) {
    return this.loadSdk().then(google => new Promise((resolve, reject) => {
      const latlng = new google.maps.LatLng(lat, lng);
      const geocoder = new google.maps.Geocoder({ region: 'BR' });

      return geocoder.geocode({ latLng: latlng }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          resolve(results);
        } else {
          const error = new Error('Geocode failed');
          error.origin = status;
          reject(error);
        }
      });
    }));
  }

  // Uses google maps api to get place autocomplete suggestions
  getPlacePredictions(input, options) {
    return this.loadSdk().then(google => new Promise((resolve, reject) => {
      const autocompleteService = new google.maps.places.AutocompleteService();
      autocompleteService.getPlacePredictions(Object.assign({}, options, { input }), (predictions, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK || status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
          resolve(predictions);
        } else {
          const error = new Error('Place predictions failed');
          error.origin = status;
          reject(error);
        }
      });
    }));
  }

  // Get lat, lng details from a placeId. This is used because getPlacePredictions method doesn't return (lat, lgn)
  geocodeFromPlace(placeId) {
    return this.loadSdk().then(google => new Promise((resolve, reject) => {
      const geocoder = new google.maps.Geocoder({ region: 'BR' });

      geocoder.geocode({ placeId }, (details, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          const result = details && details.length ? details[0] : details;
          resolve(result);
        } else {
          const error = new Error('Geocode place failed');
          error.origin = status;
          reject(error);
        }
      });
    }));
  }

  cleanAddress(address) {
    return address && address
      .replace(/, Brasil$/i, '')
      .replace(/(,\s)?\d{5}-\d{3}/, ''); // Zip codes like 12345-123
  }
}

const isTestEnv = window.QB && window.QB.isTestEnv;

if (isTestEnv) {
  window.QB.GoogleMapsService = new GoogleMapsServiceStub();
}

export default isTestEnv ? window.QB.GoogleMapsService : new GoogleMapsService();
